import React from 'react';
import { IconFullscreen, IconFullscreenExit, IconVideo } from '../icons';

export default function FullscreenToggleButton({
  t,
  cx,
  hasVideo,
  isMobileViewport,
  isFullscreen,
  setIsFullscreen,
  isVideoFullscreen,
  setIsVideoFullscreen,
  showVideoWindow,
  setShowVideoWindow,
  videoWindowStyle
}) {
  const displayedVideoWidth = (() => {
    try {
      const w = videoWindowStyle?.width;
      const n = typeof w === 'string' ? parseFloat(w) : NaN;
      return Number.isFinite(n) ? n : null;
    } catch (_) {
      return null;
    }
  })();

  const isVideoFullWidth =
    !!hasVideo &&
    !isVideoFullscreen &&
    displayedVideoWidth !== null &&
    displayedVideoWidth >= (window.innerWidth - 2);

  const isMobile = (() => {
    try { return window.innerWidth < 768; } catch (_) { return false; }
  })();

  const canShow = hasVideo
    ? (isMobile ? true : (isVideoFullscreen || !isVideoFullWidth))
    : false;

  if (!canShow) return null;

  return (
    <button
      aria-pressed={hasVideo ? (isMobileViewport ? !!showVideoWindow : !!isVideoFullscreen) : !!isFullscreen}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (hasVideo) {
          if (isMobileViewport) {
            setShowVideoWindow?.((prev) => !prev);
            return;
          }
          setIsVideoFullscreen?.((prev) => !prev);
          return;
        }
        setIsFullscreen?.((prev) => !prev);
      }}
      className={cx(
        'absolute top-1 right-1 z-[100] h-5 w-5 inline-flex items-center justify-center rounded',
        'transition-all duration-150 cursor-pointer select-none',
        (hasVideo ? (isMobileViewport ? showVideoWindow : isVideoFullscreen) : isFullscreen)
          ? 'text-white bg-emerald-600/80 shadow-inner ring-1 ring-black/40 translate-y-[1px]'
          : 'text-white/85 shadow-[0_2px_6px_rgba(0,0,0,0.45)] bg-emerald-500/12 border border-emerald-400/25 hover:bg-emerald-500/18'
      )}
      style={{ pointerEvents: 'auto' }}
      title={hasVideo
        ? (isMobileViewport
            ? (showVideoWindow ? '隐藏视频窗口' : '显示视频窗口')
            : (isVideoFullscreen ? t('player.exitFullscreen') : '全屏视频'))
        : (isFullscreen ? t('player.exitFullscreen') : t('player.fullscreenLyrics'))}
      data-no-toggle
    >
      {hasVideo ? (
        isMobileViewport ? (
          <IconVideo className={cx('w-3.5 h-3.5', showVideoWindow ? 'text-white' : 'text-white/55')} />
        ) : isVideoFullscreen ? (
          <IconFullscreenExit className="w-3 h-3" />
        ) : (
          <IconFullscreen className="w-3 h-3" />
        )
      ) : isFullscreen ? (
        <IconFullscreenExit className="w-3 h-3" />
      ) : (
        <IconFullscreen className="w-3 h-3" />
      )}
    </button>
  );
}

